import React, { ComponentProps } from "react";
import { cls } from "cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";

interface PriceWithDivideByProps extends ComponentProps<"span"> {
  price: number;
  divideByUnit: string;
  divideByQuantity: number;
}

const DivideByPrice = ({
  className,
  price,
  divideByUnit,
}: PriceWithDivideByProps) => (
  <span
    className={cls("font-normal text-gray-600", className)}
    data-testid="divide-by-unit-price"
  >
    {formatAsCurrency.formatIfUndefined(price)}/{divideByUnit}
  </span>
);

export default DivideByPrice;
